module.exports = __webpack_public_path__ + "img/schedule3.f02bdd10.svg";